import * as ActionTypes from '../constants/actions';

const default_state = {
	contacts : []
};

export default function contact(state = default_state, action) {
	switch (action.type) {
		case ActionTypes.CONTACTS.APPEND_MY_CONTACT_LIST: {
			return {
				...state,
				contacts : action.contact
			};
		}
		default: {
			return state;
		}
	}
}
